<template>
  <div>
    <hero />
    <b-container>
      <b-row>
        <b-col md="6">
          <post-list />
        </b-col>
        <b-col md="6">
          <event-list />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import Hero from "../components/Hero.vue";
import PostList from "../components/PostList.vue";
import EventList from "../components/EventList.vue";
import Modals from "../classes/Modals";

export default {
  components: {
    Hero,
    PostList,
    EventList
  },
  metaInfo:{
    title: 'Faith Christian Church Evansville: Home',
    htmlAttrs: {
      lang: 'en',
      amp: true
    },
    meta: [{
      vmid: "description",
      name: "description",
      property: "description",
      content: 'Welcome to Faith Christian Church Evansville! Located in Evansville, WI. Our pastor is Jerry Dean. Our mission is Bringing people to faith and maturity in Christ.',
    }]
  },
  mounted() {
    if (this.$route.meta.showModal) {
      setTimeout(() => this.$root.$emit("bv::show::modal", Modals.give));
    }
  }
};
</script>